import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const body = css`
  text-align: center;
  max-width: 30rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${dimensions.tablet}) {
    max-width: 40rem;
  }
`;

export const button = css`
  margin-block: 0.5rem;
  width: 100%;

  @media (min-width: ${dimensions.tablet}) {
    margin-left: auto;
    width: auto;
  }
`;
